module.exports = __webpack_public_path__ + "static/media/img187.8b10a1aa.jpg";